if (!customElements.get('recently-viewed')) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.options = {
        slidesPerView: this.hasAttribute('data-alt') ? 2.206 : 1,
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
        },
      };
    }

    setProductUrlInStorage(currentStorage = []) {
      if (!this.dataset.productUrl);
      this.urls = new Set(currentStorage);
      this.urls.delete(this.dataset.productUrl);
      this.urls.add(this.dataset.productUrl);

      localStorage.setItem(
        'recently-viewed',
        JSON.stringify(Array.from(this.urls))
      );
    }

    initSlider() {
      const element = this.querySelector('[data-slider]');

      if (!element || !Swiper) return;

      this.slider = new Swiper(element, this.options);
    }

    renderProducts(urls) {
      Promise.all(
        urls.map((url) => fetch(url + `?view=${this.dataset.type}`))
      ).then((values) => {
        Promise.all(values.map((value) => value.text())).then(
          (items) => {
            if (items.length > 0) {
              items.forEach((item) => {
                if (item.includes('js-slide-flag'))
                  this.wrapper.insertAdjacentHTML(
                    'beforeend',
                    `<div class="swiper-slide">${item}</div>`
                  );
              });

              this.classList.remove('hidden');
              this.initSlider();
            }
          }
        );
      });
    }

    connectedCallback() {
      this.wrapper = this.querySelector('[data-slider-wrapper]');

      const currentStorage = JSON.parse(
        localStorage.getItem('recently-viewed')
      );

      if (!this.wrapper || !currentStorage?.length)
        return this.setProductUrlInStorage();

      currentStorage.filter((value, index) => {
        if (value == this.dataset.productUrl) {
          currentStorage.splice(index, 1);
          return true;
        }

        return false;
      });

      this.renderProducts(currentStorage.reverse().slice(0, 10));

      return this.setProductUrlInStorage(currentStorage);
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
}
